import React, { useState } from "react";
import "./SearchFilter.css";
import { DropDownList, AutoComplete } from "@progress/kendo-react-dropdowns";
import { Form, Button, InputGroup, Collapse } from "react-bootstrap";
import { GetApplicantName } from "../../apis/OrderAPI";
import * as BsIcons from "react-icons/bs";

export const FormFilter = ({
  search,
  formStatuses,
  requestorid,
  investigatorid,
  advSearch,
  displayShort,
  shortFields,
  sortOrder
}) => {
  const [open, setOpen] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [applicantNames, setApplicantNames] = useState([]);
  const [applicantName, setApplicantName] = useState("");
  const [creationStartDate, setCreationStartDate] = useState("");
  const [creationEndDate, setCreationEndDate] = useState("");
  const [isActive, setIsActive] = useState(false);

  const defaultFormStatus = {
    statusId: 0,
    statusName: "Choose Status...",
  };

  const [formStatus, setFormStatus] = useState(defaultFormStatus);


  const defaultSort = {
    value: "",
    text: "Order By",
  };
  
  const [sortBy, setSortBy] = useState(defaultSort);

  const getApplicantNames = async (e) => {
    let searchName = e.value;
    setApplicantName(searchName);
    setIsActive(true);
    if (searchName.length > 2) {
      var result = await GetApplicantName({
        searchName,
        requestorid,
        investigatorid,
      });
      setApplicantNames(result.data);
    }
  };

  const clearFilter = () => {
    setCreationStartDate("");
    setCreationEndDate("");
    setApplicantName("");
    setFormStatus(defaultFormStatus);
    setIsActive(false);
  };

  const handleCreationStartDate = (e) => {
    let rstdt = e.target.value;
    if (rstdt !== "") {
      var stdt = new Date(e.target.value);
      if (creationEndDate != null && creationEndDate !== "") {
        var endt = new Date(creationEndDate);
        if (stdt > endt) setCreationEndDate(rstdt);
        setCreationStartDate(rstdt);
        setIsActive(true);
      } else setCreationStartDate(rstdt);
    } else setCreationStartDate(rstdt);
  };

  const handleCreationEndDate = (e) => {
    let rendt = e.target.value;
    if (rendt !== "") {
      var endt = new Date(e.target.value);
      if (creationStartDate != null && creationStartDate !== "") {
        var stdt = new Date(creationStartDate);
        if (endt < stdt) setCreationStartDate(rendt);
        setCreationEndDate(rendt);
        setIsActive(true);
      } else setCreationEndDate(rendt);
    } else setCreationEndDate(rendt);
  };

  return (
    <>
      <div className="filters-option">
        <div className="search-by-filter">
          <InputGroup>
            <Form.Control
              placeholder="Search by Name"
              aria-label="Search by"
              aria-describedby="Search-by"
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
            />
            <Button
              className="search-btn"
              type="button"
              id="Search-by"
              onClick={() => search(searchValue)}
            >
              <i className="fa-solid fa-magnifying-glass"></i>
            </Button>
          </InputGroup>
        </div>
        <div className="multi-options-filter">
          <button
            className="btn btn-options-filter"
            onClick={() => setOpen(!open)}
            aria-expanded={open}
            aria-controls="example-collapse-text"
          >
            <i className="fa-solid fa-filter"></i>
          </button>
          <Collapse className="filter-box" in={open}>
            <div className="filter-box-inner" id="example-collapse-text">
              <Button
                className="filter-box-close"
                onClick={() => setOpen(!open)}
              >
                <BsIcons.BsXLg />
              </Button>
              <Form className="filter-box-form">
                <Form.Group className="mb-4 row" controlId="CompletionDates">
                  <Form.Label className="col-lg-4 col-md-6 col-sm-12">
                    Completion Dates:
                  </Form.Label>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <Form.Control
                      type="date"
                      placeholder="From"
                      value={creationStartDate}
                      onChange={handleCreationStartDate}
                    />
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <Form.Control
                      type="date"
                      placeholder="To"
                      value={creationEndDate}
                      onChange={handleCreationEndDate}
                    />
                  </div>
                </Form.Group>
                <Form.Group className="mb-4 row" controlId="ApplicantName">
                  <Form.Label className="col-lg-4 col-md-6 col-sm-12">
                    Applicant Name:
                  </Form.Label>
                  <div className="col-lg-8 col-md-6 col-sm-12">
                    <AutoComplete
                      className="custom-form-control"
                      data={applicantNames}
                      placeholder="e.g. Adam"
                      value={applicantName}
                      onChange={getApplicantNames}
                    />
                  </div>
                </Form.Group>
                <Form.Group className="mb-4 row" controlId="FormStatus">
                  <Form.Label className="col-lg-4 col-md-6 col-sm-12">
                    Forms Status:
                  </Form.Label>
                  <div className="col-lg-8 col-md-6 col-sm-12">
                    <DropDownList
                      className="custom-form-control-select"
                      data={formStatuses}
                      textField="statusName"
                      dataItemKey="statusId"
                      defaultItem={defaultFormStatus}
                      value={formStatus}
                      onChange={(e) => setFormStatus(e.target.value)}
                    />
                  </div>
                </Form.Group>
                <div className="row">
                  <div className="col-lg-4 col-md-4 col-sm-12"></div>
                  <div className="col-lg-8 col-md-8 col-sm-12">
                    <Button
                      variant="primary"
                      disabled={!isActive}
                      className={
                        isActive
                          ? "filter-apply-btn"
                          : "filter-apply-btn-inactive"
                      }
                      type="button"
                      onClick={() => {
                        setSearchValue("");
                        advSearch({
                          creationStartDate,
                          creationEndDate,
                          applicantName,
                          formStatus,
                        });
                        setOpen(!open);
                        clearFilter();
                      }}
                    >
                      Apply
                    </Button>
                    <Button
                      className="filter-close-btn"
                      onClick={() => setOpen(!open)}
                    >
                      Close
                    </Button>
                  </div>
                </div>
              </Form>
            </div>
          </Collapse>
        </div>
        <div className="short-by-filter">
          {/* <Form.Select aria-label="Default select example">
            <option>Sort By</option>
            <option value="1">Sort By Name</option>
            <option value="2">Sort By Order</option>
            <option value="3">Sort By Status</option>
            <option value="3">Sort By Date</option>
          </Form.Select> */}
          <DropDownList
            className="custom-form-control-select sortby-filter"
            data={shortFields}
            textField="text"
            dataItemKey="value"
            defaultItem={defaultSort}
            value={sortBy}
            onChange={(e) => {setSortBy(e.target.value); sortOrder(e.target.value)}}
          />
        </div>
      </div>
    </>
  );
};
